


























import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CardTabs, { ITab } from '@/components/base/CardTabs.vue';
import ReportsTab from './ReportsCardTabs/ReportsTab.vue';
import GenerateTab from './ReportsCardTabs/GenerateTab.vue';
import ScheduleTab from './ReportsCardTabs/ScheduleTab.vue';
import { GroupsState } from '@/store/modules/groups/types';
import { CircuitsState } from '@/store/modules/circuits/types';
import { DevicesState } from '@/store/modules/devices/types';
import {
  ReportsState, ReportsAction, ReportsActionType
} from '@/store/modules/reports/types';

const circuits = namespace('circuits');
const groups = namespace('groups');
const devices = namespace('devices');
const reports = namespace('reports');

@Component({
  components: {
    CardTabs,
    ReportsTab,
    GenerateTab,
    ScheduleTab
  }
})
/**
 * @group Reports Card
 * Reports tab content
 */
export default class ReportsCard extends Vue {
  selectedTab: number = 0;

  @circuits.State circuits!: CircuitsState['circuits'];

  @groups.State groups!: GroupsState['groups'];

  @devices.State devices!: DevicesState['devices'];

  @reports.State reportsStatus!: ReportsState['reportsStatus'];

  @reports.Action(ReportsAction.FetchReportsStatus)
  fetchReportsStatus!: ReportsActionType['FETCH_REPORTS_STATUS'];

  get tabs(): ITab[] {
    return [
      { name: this.$tc('main.report', 2) as string, value: 0 },
      { name: this.$t('main.generate_reports') as string, value: 1 },
      { name: this.$t('main.schedule_reports') as string, value: 2 }
    ];
  }

  setSelectedTab(value: number | string) {
    this.selectedTab = value as number;
  }

  async mounted() {
    // Load initial data
    await this.fetchReportsStatus();
  }
}
